<template>
  <label
    :for="`${props.name}-${props.value}`"
    class="flex items-center justify-center p-2 border rounded h-12 w-full body-3 select-none"
    :class="{
      'text-n-0 border-n-300 hover:bg-n-600 cursor-pointer': model !== value && !disabled,
      'text-n-0 bg-v-300 border-v-300': model === value && !disabled,
      'text-n-400 border-n-700': disabled
    }"
  >
    <input
      type="radio"
      v-model="model"
      :id="`${props.name}-${props.value}`"
      :name="name"
      :value="value"
      :disabled="disabled"
      class="hidden"
    />
    <slot />
  </label>
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
  value: string | number | null
  disabled?: boolean
}>()

const model = defineModel<string | number | null>()
</script>
